import React, { useState } from "react";
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Keyboard } from "react-native";
import { Snackbar } from "react-native-paper"; // Import Snackbar for professional notification
import { useNavigation } from "@react-navigation/native";

const OfferScreen = ({ route }: any) => {
  const navigation = useNavigation();
  const { property } = route.params;
  const [offerAmount, setOfferAmount] = useState("");
  const [comments, setComments] = useState("");
  const [snackbarVisible, setSnackbarVisible] = useState(false);

  const handleSubmitOffer = () => {
    if (!offerAmount) {
      setSnackbarVisible(true);
      return;
    }

    // Simulate sending the offer (API call can be added here)
    setSnackbarVisible(true);

    // Hide keyboard
    Keyboard.dismiss();

    // Navigate back after delay
    setTimeout(() => {
      navigation.goBack();
    }, 2000);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Make an Offer</Text>
      <Text style={styles.propertyTitle}>{property.title}</Text>

      <TextInput
        style={styles.input}
        placeholder="Enter your offer amount"
        keyboardType="numeric"
        value={offerAmount}
        onChangeText={setOfferAmount}
      />

      <TextInput
        style={[styles.input, styles.textArea]}
        placeholder="Add a comment (optional)"
        multiline
        numberOfLines={4}
        value={comments}
        onChangeText={setComments}
      />

      <TouchableOpacity style={styles.submitButton} onPress={handleSubmitOffer}>
        <Text style={styles.submitButtonText}>Submit Offer</Text>
      </TouchableOpacity>

      {/* Snackbar Notification */}
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        duration={2000} // Auto-hide after 2 seconds
        action={{
          label: "OK",
          onPress: () => setSnackbarVisible(false),
        }}
      >
        {offerAmount ? `Your offer of ${offerAmount} CFA has been sent!` : "Please enter an offer amount."}
      </Snackbar>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: "#fff",
  },
  title: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 20,
  },
  propertyTitle: {
    fontSize: 18,
    color: "#333",
    marginBottom: 20,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 10,
    padding: 15,
    marginBottom: 20,
  },
  textArea: {
    height: 100,
  },
  submitButton: {
    backgroundColor: "green",
    padding: 15,
    borderRadius: 10,
    alignItems: "center",
  },
  submitButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default OfferScreen;
